"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getISODateTime = void 0;
const is_valid_date_1 = require("../../validation/is-valid-date/is-valid-date");
/**
 * Get datetime in ISO format yyyy-MM-ddTHH:mm:ss.SSS
 * @public
 *
 * @param date - Date to get time from
 *
 * @returns Datetime in ISO format yyyy-MM-ddTHH:mm:ss.SSS
 *
 * @example
 * ```ts
 * const isoDateTime =  getISODateTime(new Date(2021, 11, 25))
 * console.log(isoDate);
 * // -> '2021-11-25T00:00:00.000'
 * ```
 */
function getISODateTime(date) {
    let currentDate = date;
    if (!currentDate) {
        const tzoffset = new Date().getTimezoneOffset() * 60000; // offset in milliseconds
        currentDate = new Date(Date.now() - tzoffset);
    }
    return (0, is_valid_date_1.isValidDate)(currentDate)
        ? currentDate.toISOString().slice(0, -1)
        : undefined;
}
exports.getISODateTime = getISODateTime;
//# sourceMappingURL=get-ISO-date-time.js.map